import React, {Component} from 'react';
import {Button, Form, Grid, Header, Icon, Image, Modal, Popup, Segment,Divider, Message,List} from 'semantic-ui-react';
import * as placeholder from "../../assets/placeholderImage.png";
import ReportContainer from "../../containers/report_container";
import AddNewMeter from "./add_new_meter";
import AddNewReading from './add_new_reading';
import {uploadDepositaryDetails, checkOrGeneratePDF, getSearchDepositaryAddress} from "../../data/report_api";
import Loader from "../universal/loader";

const uuidv1 = require('uuid/v1');

class Depositary extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDepositarySection: false,
            inspectionType: undefined,
            readingValue: undefined,
            showCOReadingEdit: undefined,
            showCIReadingEdit: undefined,
            supplierName: undefined,
            location: undefined,
            serialNumber: undefined,
            images: {},
            depositary_uploaded:undefined,
            depositary_uploaded_deductions: undefined,
            depositary_uploaded_checkout: undefined,
            depositary_tenancy: undefined,
            gasMeter: undefined,
            waterMeter: undefined,
            electricMeter:undefined,
            processMessage:undefined,
            uploading: false,
            depositarySearchAddress: "",
            searchError:undefined,
            searchResults: [],
            loading:false
        }
    }

    searchTenancies = async () => {
        this.setState({loading:true,searchError:undefined})
        let response = await getSearchDepositaryAddress(this.state.depositarySearchAddress, this.props.reportDetails["id"])
        if (response.success) { this.setState({searchResults:response.data,searchError:response.data.length <1? "No Tenancies Found":undefined})}
        else {
            this.setState({searchError:response.data})
        }
        this.setState({loading:false})
    }
    uploadDepositary = async () => {
        this.setState({processMessage:"Checking and Generating PDF...",uploading:true})
        let response = await checkOrGeneratePDF(this.props.reportDetails["id"])
        if(response.success) {
            this.setState({processMessage:`${response.statusMessage}`}) 
            const formData = new FormData();
            formData.append("report_id",this.props.reportDetails["id"])
            formData.append("tenancy", this.state.depositary_tenancy["id"]);
            formData.append("waterMeter", this.state.waterMeter);
            formData.append("electricMeter", this.state.electricMeter);
            formData.append("gasMeter", this.state.gasMeter);
            this.setState({processMessage:`Uploading Depositary Details...`}) 
            uploadDepositaryDetails(formData).then((response) => {
                if (response.success) {
                    let deductionsUploadResponse = ""
                    let checkOutUploadResponse = ""
                    let checkoutUploadBool = false
                    let deductionsUploadBool = false
                    if (response.deductionsUploadResponse.status = "OK" && !response.deductionsUploadResponse.error )
                    {
                        deductionsUploadResponse = "Uploaded";
                        deductionsUploadBool = true;
                    }
                    else {deductionsUploadResponse = response.deductionsUploadResponse.error }

                    if (response.checkoutUploadResponse.status = "OK"&& !response.checkoutUploadResponse.error)
                    { checkOutUploadResponse = "Uploaded";checkoutUploadBool = true }
                    else {
                        checkOutUploadResponse = response.checkoutUploadResponse.error
                    }

                    this.setState({ uploading: false, depositary_uploaded:deductionsUploadBool && checkoutUploadBool, processMessage:`DEDUCTIONS RESPONSE: ${deductionsUploadResponse} ||| CHECK OUT UPLOAD RESPONSE:${checkOutUploadResponse}` })

                    // this.props.completeReport()
                } else {
                    this.setState({uploading:false,processMessage:`${response.statusMessage}`})
                } 
            })
        } else {
            this.setState({uploading:false,processMessage:`${response.statusMessage}`}) 
            }
    }

    componentWillMount() {
        this.setState({
            showDepositarySection: this.props.showDepositary,
            inspectionType: this.props.reportDetails['inspection_type'],
            depositary_uploaded: this.props.reportDetails['depositary_uploaded_deductions'] && this.props.reportDetails['depositary_uploaded_checkout'],
            depositary_uploaded_deductions: this.props.reportDetails['depositary_uploaded_deductions'],
            depositary_uploaded_checkout: this.props.reportDetails['depositary_uploaded_checkout'],
        })
    }

    successFn = () => {
        /* after each image save*/
    };

    completeCallBack = () => {
        this.props.resetDataQueuedInAPI('meters');
        this.setState({isSaving:false});
        this.props.handleClose();
    };


    render() {
        const meters = this.props.reportDetails['meters'];
        return (<Segment>
            
            {/* {this.state.processMessage && <Loader customText={this.state.processMessage} save={true}></Loader>} */}
            <Modal size="large" open={this.state.showDepositarySection} onClose={(e) => {
                this.props.handleClose();
            }}>
                <Modal.Content style={{minHeight: '500px', overflowY: 'scroll'}}>
                    <Header floated="right"><Icon className="icon-button" name="close" onClick={(e) => {
                        this.props.handleClose();
                    }}/></Header>
                    <Modal.Description>
                        <Header as='h2' textAlign='center'>
                            Depositary Upload - MAKE SURE REPORT IS SAVED BEFORE UPLOADING 
                        </Header>
                    </Modal.Description>
                    {!this.state.depositary_uploaded && <Segment>
                        {this.state.depositary_tenancy ? <Header as="h2"> <span>Tenancy Selected - {this.state.depositary_tenancy.address} </span>
                            <Button basic color="red" size="tiny" compact onClick={(() => { this.setState({ depositary_tenancy: undefined, gasMeter: undefined, waterMeter: undefined, electricMeter: undefined }) })}>Clear Tenancy</Button></Header>
                            :
                            <Header as="h2"> Select Tenancy</Header>}
                        {!this.state.depositary_tenancy && <Form><Form.Group><Form.Input onChange={(e) => { this.setState({ depositarySearchAddress: e.target.value }) }}></Form.Input><Form.Button disabled={this.state.loading} loading={this.state.loading} compact onClick={() => { this.searchTenancies() }}>Search</Form.Button></Form.Group>
                            {this.state.searchError && <Message>{this.state.searchError}</Message>}
                        </Form>}
                
                        <List selection verticalAlign='middle'>
                            {this.state.searchResults.map(result => {
                                return <List.Item key={result.uid} onClick={() => this.setState({ depositary_tenancy: { address: `${result.addressLine1},${result.addressLine2},${result.city},${result.county},${result.country},${result.postcode}`, id: result.uid }, searchResults: [] })}>
                                    <List.Icon name='marker' />
                                    <List.Content>
                                        <List.Header as='a'>{`${result.addressLine1},${result.addressLine2},${result.city},${result.county},${result.country},${result.postcode}`}</List.Header>
                                        <List.Description>
                                            {result.moveOutDate}
                                        </List.Description>
                                    </List.Content>
                                </List.Item>
                            })}
                        </List>
                    </Segment>}
                    {this.state.depositary_tenancy && <div>
                        <Segment>{!this.state.depositary_uploaded && <div>
                            <Header as="h2"> Select Meters<Button basic color="red" size="tiny" compact onClick={() => {
                                this.setState({
                                    gasMeter: undefined,
                                    waterMeter: undefined,
                                    electricMeter: undefined
                                })
                            }}> Clear Meter Selections</Button></Header>
                            {meters.map((meter) => {
                                return <Segment key={meter.client_id}><Header>{meter.name}</Header><div>
                                    <Button compact color={this.state.waterMeter == meter.client_id ? "blue" : null} onClick={() => { this.setState({ waterMeter: meter.client_id }) }}>Water Meter</Button>
                                    <Button compact color={this.state.electricMeter == meter.client_id ? "yellow" : null} onClick={() => { this.setState({ electricMeter: meter.client_id }) }}>Electric Meter</Button>
                                    <Button compact color={this.state.gasMeter == meter.client_id ? "green" : null} onClick={() => { this.setState({ gasMeter: meter.client_id }) }}>Gas Meter</Button></div></Segment>
                            })}
                            <div style={{ textAlign: "center" }}>
                            </div>
                            <Divider></Divider>
                            <div style={{ textAlign: "center" }}>
                                {!this.state.uploading && <Popup on="click" trigger={
                                    <Button negative
                                        content={
                                            <span>Start Upload (CAUTION - CAN ONLY BE DONE ONCE AND IS IRREVERSIBLE, MAKE SURE TENANCY / METERS ARE CORRECT)</span>
                                        } disabled={this.state.uploading} loading={this.state.uploading}></Button>
                                }
                                    content={<Segment><Header>Are you sure?</Header><div><Button onClick={() => { this.uploadDepositary() }}>Confirm</Button></div></Segment>}>
                        
                                </Popup>}             
                                {this.state.uploading && <Button negative loading></Button>}                           </div></div>}
                          
                            {this.state.processMessage && <Message>{(this.state.processMessage)}</Message>}
                            {this.state.depositary_uploaded && <div style={{ textAlign: "center" }}> <Button positive onClick={()=>{this.props.completeReport()}}> COMPLETE</Button></div>}
                        </Segment>
                    </div>}
                    
                </Modal.Content>
            </Modal>
        </Segment>);
    }

}

export default ReportContainer(Depositary);


// WEBPACK FOOTER //
// ./src/views/report/depositary.js